$(document).ready(function() {
  $.fn.updatecart = function(a) {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: { updates: a },
      dataType: "json",
      success: function(a) {
        var t = a.item_count;
        $("span[data-cart-count]").text(t),
        0 == t ? $("#CartCount").hide() : ($("#CartCount").removeClass("hide"), $("#CartCount").show()),
        $.ajax({
          type: "GET",
          url: "/cart?view=ajax-drawer",
          success: function(a) {
            var t = $(a).find(".tbody_mt").html(),
                r = $(a).find(".cart__subtotal").html();
            $(".tbody_mt").html(t),
            $(".cart__subtotal_drawer_mt").html(r),
            "Rs. 0.00" == r ? $(".cart_info_container_drawer_mt").hide() : $(".cart_info_container_drawer_mt").show();
          },
          error: function(a) {}
        });
      }
    });
  };

  $(".js-ajax-cart-drawer-trigger").click(function(a) {
    a.preventDefault(),
    $(".js-ajax-cart-drawer").addClass("is-open"),
    $(".js-ajax-cart-overlay").addClass("is-open"),
    $(".js_class_mt").addClass("ajax_drawer_open"),
    $("body").addClass("drawer-open");
  });

  $(".js-ajax-cart-drawer-close").click(function(a) {
    a.preventDefault(),
    $(".js-ajax-cart-drawer").removeClass("is-open"),
    $(".js-ajax-cart-overlay").removeClass("is-open"),
    $(".js_class_mt").removeClass("ajax_drawer_open"),
    $("body").removeClass("drawer-open");
  });

  $(document).on("click", "#RemoveItem_FromDrawer", function(a) {
    a.preventDefault();
    var t = {};
    t[$(this).parent().parent().parent().attr("data-variant-id")] = 0,
    $.fn.updatecart(t);
  });

  $(document).on("click", ".product__plus_drawe_mt", function(a) {
    a.preventDefault();
    var t = $(this).siblings(".quantity_update_Drawer_MT"),
        r = $(this).siblings(".quantity_update_Drawer_MT").val(),
        e = parseInt(r) + 1;
    return t.val(e).trigger("change"), !1;
  });

  $(document).on("click", ".product_minus_drawe_mt", function(a) {
    a.preventDefault();
    var t = $(this).siblings(".quantity_update_Drawer_MT"),
        r = ($(this).siblings(".quantity_update_Drawer_MT").val(), parseInt(t.val()) - 1);
    return console.log(r),
    r < 1 && $("#RemoveItem_FromDrawer").trigger("click"),
    t.val(r).trigger("change"), !1;
  });

  $(document).on("change", ".quantity_update_Drawer_MT", function(a) {
    a.preventDefault();
    var t = {},
        r = $(this).parent().parent().parent().attr("data-variant-id"),
        e = $(this).val();
    t[r] = parseInt(e),
    $.fn.updatecart(t);
  });
});

// $(".product-ATC-btn").click(function(a) {
//   a.preventDefault();
//   var t = $(this).parents("form").find("#selected_variant_val").val(),
//       r = { id: t, quantity: 1 };
//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: r,
//     dataType: "json",
//     success: function(a) {
//       $.fn.updatecart(t),
//       setTimeout(function() {
//         $(".js-ajax-cart-drawer-trigger").trigger("click");
//       }, 1e3);
//     }
//   });
// });

$(".product-ATC-btn").click(function(a) {
  a.preventDefault();
  
  var $btn = $(this);
  var $form = $btn.closest("form");
  var variantId = $form.find("#selected_variant_val").val();

  $btn.addClass('loading');

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: $form.serialize(),
    dataType: "json",
    success: function(response) {
      $btn.removeClass('loading');
      
      if (typeof $.fn.updatecart === 'function') {
        $.fn.updatecart(variantId);
      }

      setTimeout(function() {
        $(".js-ajax-cart-drawer-trigger").trigger("click");
      }, 500);
    },
    error: function(xhr) {
      $btn.removeClass('loading');
      var err = JSON.parse(xhr.responseText);
      console.error(err.description);
    }
  });
});

$(document).ready(function() {
  $(".ajax_cart__overlay").click(function() {
    $(".js-ajax-cart-drawer").removeClass("is-open"),
    $(".js-ajax-cart-overlay").removeClass("is-open"),
    $(".js_class_mt").removeClass("ajax_drawer_open"),
    $("body").removeClass("drawer-open");
  });
});
